import React, { useState } from 'react';
// MODIFIED: the old handleButtonClick rendered a <Route> inside a click handler, which
// does nothing. It now navigates to the Models page carrying the search term.
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../Components/AuthProvider';
import About from '../About/index';

export default function Home() {
    const [searchModelInput, setSearchModelInput] = useState('');
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();

    const handleSubmit = (e) => {
        e.preventDefault();
        // Signed-out visitors get sent to log in first; ProtectedRoute brings them back
        const target = searchModelInput
            ? `/models?search=${encodeURIComponent(searchModelInput)}`
            : '/models';
        navigate(isAuthenticated ? target : '/login');
    };

    return (
        <>
            {/* MODIFIED: the hero was a bordered box sitting on a grey slab. It is now a
                full-bleed section with a soft red glow behind the wordmark, which gives
                the page a focal point and lets the About section below flow out of it
                instead of looking like a second, unrelated card. */}
            <section className="relative overflow-x-clip cv-page">

                {/* Decorative glow. aria-hidden: it carries no meaning for a screen reader. */}
                <div aria-hidden="true"
                     className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 h-[28rem] w-[28rem] rounded-full blur-3xl opacity-20"
                     style={{ background: 'radial-gradient(circle, var(--accent) 0%, transparent 70%)' }} />

                <div className="relative max-w-4xl mx-auto text-center px-4 py-16 sm:py-24 animate-fade-up">
                    <p className="cv-eyebrow">Welcome to</p>

                    {/* The wordmark, split across two weights so it reads as a logo.
                        MODIFIED: the base size is set in rem rather than text-6xl - at 60px
                        "CLOUDVAULT" is wider than a 375px phone and was being clipped. */}
                    <h1 className="font-display font-bold leading-[0.9] text-[2.6rem] sm:text-7xl md:text-8xl lg:text-9xl mt-3">
                        {/* MODIFIED: renamed from CLOUD VAULT - same 10 letters, so it still fits a phone */}
                        <span className="cv-strong">SPEED</span>
                        <span className="cv-accent italic">VAULT</span>
                    </h1>

                    {/* Speed stripe under the wordmark, echoing the one below the nav bar */}
                    <div className="cv-stripe w-32 sm:w-48 mx-auto mt-5 rounded-full" />

                    <p className="mt-6 text-base sm:text-lg cv-body max-w-xl mx-auto">
                        Every car you own, catalogued, organised and valued. Create and manage all your
                        <img src="img/hotwheels-logo.png" alt="Hot Wheels" className="w-16 h-5 inline mx-1.5 align-middle" />
                        collections in the same place.
                    </p>

                    {/* MODIFIED: the search box and button are now one pill on desktop and
                        stack on phones, instead of two full-width blocks at every size */}
                    <form onSubmit={handleSubmit} className="mt-8 max-w-xl mx-auto flex flex-col sm:flex-row gap-3">
                        <div className="relative flex-1">
                            <input
                                id="searchModelInput"
                                value={searchModelInput}
                                onChange={(e) => setSearchModelInput(e.target.value)}
                                type="text"
                                autoComplete="off"
                                placeholder="Search for a model..."
                                className="cv-input rounded-full pl-11 py-3"
                            />
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
                                 className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 cv-muted pointer-events-none">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                            </svg>
                        </div>
                        <button type="submit" className="cv-btn cv-btn-primary rounded-full px-8 py-3 uppercase">
                            Get started
                        </button>
                    </form>

                    {/* A quiet nudge for signed-out visitors, so the button is not a dead end */}
                    {!isAuthenticated &&
                        <p className="mt-4 text-xs cv-muted">You will be asked to sign in first. It takes a minute.</p>
                    }
                </div>
            </section>

            <About />
        </>
    );
}
